import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';
import { GestureResponderEvent } from 'react-native';

import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import {
  PaymentNotAvailableContainer,
  PaymentNotAvailableLink,
  PaymentNotAvailableMessage,
  PaymentNotAvailableText,
} from './styled';

interface IPaymentNotAvailableProps {
  collapsed?: boolean;
  onPress?: (e: GestureResponderEvent) => void;
  isExpired?: boolean;
  isQuickPay?: boolean;
}

export const PaymentNotAvailable: React.FC<IPaymentNotAvailableProps> = ({
  collapsed,
  onPress,
  isExpired = false,
  isQuickPay = false,
}) => {
  const message = isExpired ? t('expiredCard') : t('unverifiedCard');
  const { setIsQuickPayMethodSelected } = usePaymentContext();

  return (
    <PaymentNotAvailableContainer
      isCollapsed={collapsed}
      testID="payment-not-available-badge"
      onPress={onPress}
    >
      <Icon
        variant="warning"
        color={getDesignToken('color-error')}
        size={5}
        {...hiddenAccessibilityPlatformProps}
      />
      <PaymentNotAvailableText>
        <PaymentNotAvailableMessage>{message}</PaymentNotAvailableMessage>
        <PaymentNotAvailableLink
          onPointerDown={() =>
            isQuickPay ? setIsQuickPayMethodSelected(true) : setIsQuickPayMethodSelected(false)
          }
        >
          {t('update')}
        </PaymentNotAvailableLink>
      </PaymentNotAvailableText>
    </PaymentNotAvailableContainer>
  );
};
